<template>
  <div class="page home">
    <div class="page-content">
      <swiper class="swiper" ref="swiper" :options="options">
        <swiper-slide v-for="(item, index) in sliderHero" :key="index">
          <v-banner class="banner" :style="{backgroundImage:'url('+item.src+')'}">
            <v-container class="px-4">
              <v-row>
                <v-col class="col-12 col-md-5 pa-0">
                  <v-row class="content">
                    <v-col class="col-12 mb-16 pa-0">
                      <h1 class="main-title">{{item.title}}</h1>
                    </v-col>
                    <v-col class="col-12 mb-7 pa-0">
                      <div class="sub-title1">{{item.content}}</div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-banner>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
      <v-container class="content mt-16 px-4 ">
        <v-row class="mb-2">
          <v-col class="col-12 col-md-9 pa-0 pr-md-6 mb-8 mb-md-0">
            <Card head title="招采信息" @more="goEngineering">
              <Tabs title="engineering" headCenterTitle="公司" :pagination="false" :list="engineeringItems"></Tabs>
            </Card>
          </v-col>
          <v-col class="col-12 col-md-3 col-lg-3 col-xl-3 pa-0">
            <DataBase></DataBase>
          </v-col>
        </v-row>
      </v-container>
      <v-container class="content px-4 mb-8">
        <News></News>
      </v-container>
      <div class="background-1 mb-8">
        <v-container class="content px-4">
          <v-row class="mb-4">
            <v-col class="col-12 pa-0 mb-8 mb-md-0">
              <SupplyChains></SupplyChains>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <v-container class="content px-4">
        <v-row class="mb-8">
          <v-col class="col-12 col-lg-9 mb-4 mb-lg-0 pr-lg-6 pa-0">
            <Card head title="项目公告" @more="goLogistics">
              <Tabs title='logistics' :pagination="false" head-left-title="项目名称" head-right-title="发布时间" :list="logisticsItems"></Tabs>
            </Card>
          </v-col>
          <v-col class="col-12 col-lg-3 mb-4 pa-0">
            <RegulatoryOrganization></RegulatoryOrganization>
          </v-col>
          <v-col class="col-12 pa-0">
            <v-row>
              <v-col class="col-12 col-lg-6 col-xl-4 pa-0 pr-lg-6 mb-4 mb-lg-0">
                <Card head title="采购交易额(物料)" :more="false">
                  <Chart1></Chart1>
                </Card>
              </v-col>
              <v-col class="col-12 col-lg-6 col-xl-4 pa-0 pr-xl-6 mb-4 mb-xl-0">
                <Card head title="每月活跃供应商数量" :more="false">
                  <Chart2></Chart2>
                </Card>
              </v-col>
              <v-col class="col-12 col-xl-4 pa-0">
                <Card head title="每月定标项目数量" :more="false">
                  <Chart3></Chart3>
                </Card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
      <div class="background-2">
        <v-container class="content px-4">
          <v-row>
            <v-col class="col-12 pa-0">
              <Company></Company>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>
    <CFooter></CFooter>
  </div>
</template>

<script>
import CFooter from '@/components/Common/Footer'
import { DataBase, SupplyChains, News, RegulatoryOrganization, Company, Chart3, Chart2, Chart1 } from '@/components/Home'
import { formatTime } from '@/utils'
import { Card, Tabs } from '@/components/UI'
// import { EngineeringTab } from '@/mixins/engineering'
// import { LogisticsTab } from '@/mixins/logistics'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import { NewEngineeringTab, NewLogisticsTab } from '@/mixins'
export default {
  name: 'Home',
  mixins: [NewEngineeringTab, NewLogisticsTab],
  components: {
    CFooter,
    Card,
    DataBase,
    Tabs,
    SupplyChains,
    News,
    RegulatoryOrganization,
    Company,
    Chart1,
    Chart2,
    Chart3,
    Swiper,
    SwiperSlide
  },
  data: () => {
    return {
      options: {
        autoplay: true,
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev'
        // },
        // loop: true,
        grabCursor: true
      },
      sliderHero: [{
        id: 0,
        title: '公平',
        content: '机会合理平等',
        src: 'https://fuzhouctyc-1304320772.cos.ap-guangzhou.myqcloud.com/%E7%A6%8F%E5%B7%9E2.jpg'
      }, {
        id: 1,
        title: '公开',
        content: '信息阳光透明',
        src: 'https://fuzhouctyc-1304320772.cos.ap-guangzhou.myqcloud.com/%E7%A6%8F%E5%B7%9E3.jpg'
      }, {
        id: 2,
        title: '公正',
        content: '评审依规合法',
        src: 'https://fuzhouctyc-1304320772.cos.ap-guangzhou.myqcloud.com/%E7%A6%8F%E5%B7%9E5.jpg'
      }, {
        id: 3,
        title: '高效',
        content: '流程快速有序',
        src: 'https://fuzhouctyc-1304320772.cos.ap-guangzhou.myqcloud.com/%E7%A6%8F%E5%B7%9E2.jpg'
      }]
    }
  },
  methods: {
    formatTime,
    goEngineering () {
      debugger
      if (this.$store.state.homeTab[0] === 0) {
        this.$router.push('/logistics?logisticsTab=4')
      } else {
        const engineeringTab = this.$store.state.homeTab[0]
        this.$router.push('/engineering?engineeringTab=' + engineeringTab)
      }
    },
    goLogistics () {
      debugger
      const logisticsTab = this.$store.state.homeTab[1]
      this.$router.push('/logistics?logisticsTab=' + logisticsTab)
    }
  }
}
</script>
<style lang="scss" scoped>
.banner {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: #FFF!important;
}
.banner:after {
  background: linear-gradient(180deg, #0000005e 0, rgba(0, 0, 0, 0.16) 50%, #00000036 100%);
  content: '';
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
}
.home {
  .background-2 {
    background-image: url('../assets/images/background-2.png');
    background-size: cover;
  }
  .background-1 {
    background-image: url('../assets/images/background-1.png');
    background-size: cover;
  }
  .btn-detail {
    background-color: $main-color !important;
    color: #FFF;
  }
  .banner {
    padding-top: 190px;
    padding-bottom: 100px;
    @media (max-width: 1263px) {
      padding-top: 80px;
      margin-top: 72px;
    }
    .v-container {
      padding-bottom: 100px;
    }
    .content {
      margin-left: 0;
      margin-right: 0;
      line-height: 1;
    }
    .main-title {
      line-height: 85px;
      font-size: 58px;
      font-weight: bold;
      color: #fff;
    }
    .sub-title1 {
      font-size: 36px;
      color: #fff;
    }
    .sub-title2 {
      font-size: 18px;
    }
  }
}
</style>
<style lang="scss">
.home {
  .card-title {
    font-size: 18px;
    font-weight: 500;
    color: #3171b7;
  }
  .data-base {
    .card-title {
      color: #fff;
    }
  }
  .v-banner__wrapper {
    padding: 0 !important;
  }
}
.card {
  .tabs {
    background-color: #F9F9F6;
  }
  .head {
    border-bottom: 1px solid #3171b7;
  }
  .v-tabs-items,
  .v-data-table {
    background-color: transparent;
  }
}
</style>
